import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_AUTORIZADOR_PORT}${process.env.VUE_APP_API_PATH}/autorizadorfinanceiro
`;

const urlBase = `${api}/borderos`;

export default {
    obterQuantidade() {
        return axiosJwt.get(`${urlBase}/quantidade-aguardando-aprovacao`);
    },
};
